import { render, staticRenderFns } from "./islemcomp.vue?vue&type=template&id=0da49c73&"
import script from "./islemcomp.vue?vue&type=script&lang=js&"
export * from "./islemcomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports